import { useRouter } from 'next/router';
import EntityChip from '@/atoms/chips/EntityChip';
import Heading from '@/atoms/typography/Heading';
import IconHeading from '@/molecules/headings/IconHeading/IconHeading';
import DateListItem from '@/molecules/lists/Date/DateListItem';
import List from '@/molecules/lists/List';
import { shortenId } from '@beamible/uuid';
import Size from '@enums/Size';
import ActionIcon from '@mui/icons-material/EventAvailableRounded';
import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
import Stack from '@mui/material/Stack';
import { DesignEntity, SurveyStatus } from '@/lib/enums';
import getSurveyListItems from './getSurveyListItems';

const SurveysList = ({ surveys }) => {
  const router = useRouter();

  const openSurveys = surveys.filter(
    (survey) =>
      survey.role &&
      (survey.status === SurveyStatus.NOT_STARTED ||
        survey.status === SurveyStatus.IN_PROGRESS)
  );

  const n = openSurveys.length;
  const showEntityTitles = n > 1;
  const subtitle = `You have ${n} outstanding action${n > 1 ? 's' : ''}`;
  const noneSubtitle = `You don't have any outstanding actions`;
  const roles = getSurveyListItems(openSurveys);

  const handleClick = (_, item) => {
    const shortId = shortenId(item.id);
    const parts = [`/s/${shortId}`];

    const key = router?.query?.key ?? null;
    if (key) parts.push(`?key=${key}`);

    const url = parts.join('');
    router.push(url);
  };

  return (
    <>
      <IconHeading
        color="tertiary"
        icon={<ActionIcon />}
        size={Size.LARGE}
        subtitle={n > 0 ? subtitle : noneSubtitle}
        title="Actions"
      />
      {Array.from(roles.entries()).map(([id, role]) => (
        <Grow key={id} in={true} timeout={500}>
          <Box mb={role.surveys.length > 1 ? 2 : 0} mt={3}>
            {' '}
            {showEntityTitles && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                mb={1}
                ml={0.5}
              >
                <EntityChip type={DesignEntity.ROLE} size={Size.X_SMALL} />
                <Heading variant="h4" overrideStyles={{ fontWeight: 500 }}>
                  {role.title}
                </Heading>
              </Stack>
            )}
            <List
              items={role.surveys}
              ListItem={<DateListItem />}
              onClick={handleClick}
            />
          </Box>
        </Grow>
      ))}
    </>
  );
};
export default SurveysList;
